import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Layout } from 'antd';
import {
  UploadOutlined,
  UnorderedListOutlined,
  HistoryOutlined,
  LogoutOutlined,
  MenuOutlined
} from '@ant-design/icons';
import styled from 'styled-components';
import Logo from './humber-logo.png';
import { AuthContext } from '../../PrivateRoute/AuthProvider';
import useToast from '../../Global/outdatedVersionToast';

const { Header } = Layout;

const CustomHeader = styled(Header)`
  && {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #1f1f1f !important;
    padding: 0 24px;
    height: auto !important;
    min-height: 80px;
    line-height: normal !important;
    border-bottom: 1px solid #333;
  }
`;

const LogoContainer = styled.div`
  width: 120px;
  display: flex;
  align-items: center;

  img {
    max-height: 50px;
    max-width: 100%;
    width: auto;
  }
`;

const NavItemsContainer = styled.div`
  display: flex;
  align-items: center;
`;

const DesktopMenu = styled.div`
  display: flex;
  
  @media (max-width: 992px) {
    display: none;
  }
`;

const NavItem = styled(Link)`
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.65);
  padding: 0 16px;
  height: 100%;
  transition: color 0.3s;

  &:hover {
    color: #fff;
  }

  .anticon {
    margin-right: 8px;
    font-size: 16px;
  }
`;

const MobileMenuButton = styled.div`
  display: none;
  font-size: 24px;
  color: white;
  cursor: pointer;
  
  @media (max-width: 992px) {
    display: block;
  }
`;

const MobileMenu = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  width: 250px;
  background: #1f1f1f;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  
  &.open {
    display: block;
  }

  a {
    display: flex;
    align-items: center;
    padding: 12px 24px;
    color: rgba(255, 255, 255, 0.65);
    
    &:hover {
      color: #fff;
      background: #1890ff;
    }

    .anticon {
      margin-right: 12px;
    }
  }
`;

const PointNav = () => {
  const { logout } = useContext(AuthContext);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  
  const logOut = async () => {
    await logout();
    setMobileMenuVisible(false);
  };

  const menuItems = [
    { 
      label: 'Subir cargas', 
      key: 'upload-loads', 
      icon: <UploadOutlined />, 
      path: '/point' 
    },
    { 
      label: 'Cargas activas', 
      key: 'active-loads', 
      icon: <UnorderedListOutlined />, 
      path: '/point/active-loads' 
    },
    { 
      label: 'Historial', 
      key: 'history', 
      icon: <HistoryOutlined />, 
      path: '/point/point-record' 
    },
    { 
      label: 'Salir', 
      key: 'logout', 
      icon: <LogoutOutlined />, 
      path: '/', 
      action: logOut 
    },
  ];

  useToast();

  return (
    <CustomHeader>
      <LogoContainer>
        <Link to="/">
          <img src={Logo} alt="humber logo" />
        </Link>
      </LogoContainer>
      
      <NavItemsContainer>
        <DesktopMenu>
          {menuItems.map(item => (
            <NavItem 
              key={item.path}
              to={item.path}
              onClick={() => item.action && item.action()}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavItem>
          ))}
        </DesktopMenu>
        
        <MobileMenuButton onClick={() => setMobileMenuVisible(!mobileMenuVisible)}>
          <MenuOutlined />
        </MobileMenuButton>
      </NavItemsContainer>
      
      <MobileMenu className={mobileMenuVisible ? 'open' : ''}>
        {menuItems.map(item => (
          <Link 
            key={item.path}
            to={item.path}
            onClick={() => {
              if (item.action) item.action();
              setMobileMenuVisible(false);
            }}
          >
            {item.icon}
            <span>{item.label}</span>
          </Link>
        ))}
      </MobileMenu>
    </CustomHeader>
  );
};

export default PointNav;
